module.exports = __webpack_public_path__ + "media/images/icons/outlined/whats-app-0f6af8de43cc5ba2af43450dcc899509.svg";